import React from 'react';
import ReactDOM from 'react-dom';
import Game from './App';

ReactDOM.render(
  <React.StrictMode>
    <Game />
  </React.StrictMode>,
  document.getElementById('root')
);

